export type HotJarEventName = 'doctor_appointment_no_show' |
  'doctor_treatment_prescription_issued_show' |
  'doctor_appointment_attended'

const HotJarEvents: Record<string, HotJarEventName> = {
  // Appointments
  appointmentNoShow: 'doctor_appointment_no_show',
  appointmentAttended: 'doctor_appointment_attended',
  // Prescription
  prescriptionIssued: 'doctor_treatment_prescription_issued_show'
};

export default HotJarEvents;
